// import React from "react";
// import { Link } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import { mainURL, prodURL } from "../utils/common";
// import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";

// const Quick_Links = () => {
//   const { t } = useTranslation();
//   return (
//     <>
//       <section id="hero" className="hero hero2">
//         <LeftSocialMediaIconUI />
//         <div className="carousel-item active">
//           <img
//             src="assets/img/inner-bg2.png"
//             className="img-fluid"
//             alt="alt"
//           />
//           <div className="container">
//             <div className="section-main-heading2"></div>
//           </div>
//         </div>
//       </section>
//       {/* End Slider */}
//       <section className="section inner-pad1">
//         <div className="container">
//           <div className="row">
//             <div className="inner-title2 quick-t">
//               <h3> {t("Quick Links")} </h3>
//             </div>

//             <div className="col-lg-4">
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li className="nav-item has-submenu">
//                       <button
//                         type="button"
//                         className="btn "
//                         data-toggle="collapse"
//                         data-target="#demo"
//                       >
//                         {t("Make Online Payment")}
//                         <i className="bi bi-chevron-down" />
//                       </button>
//                       <div id="demo" className="collapse quick-scrl">
//                         <li className="nav-item">
//                           <button
//                             type="button"
//                             className="btn"
//                             data-toggle="collapse"
//                             data-target="#demo7"
//                           >
//                             {t("Property Tax")}
//                             <i className="bi bi-chevron-down" />
//                           </button>
//                           <div id="demo7" className="collapse">
//                             <li className="nav-item">
//                               <a
//                                 className="nav-link fontSizeClass"
//                                 href={`${prodURL}/citizen/withoutAuth/online-payment`}
//                               >
//                                 {t("Pay All Bill(Quick Pay)")}
//                               </a>
//                             </li>
//                             <li className="nav-item">
//                               <a
//                                 className="nav-link fontSizeClass"
//                                 href={`${prodURL}/citizen/language-selection`}
//                               >
//                                 {t("Pay All Bill,Suspense,Misc")}
//                               </a>
//                             </li>
//                             {/* <li className="nav-item"><a className="nav-link fontSizeClass" href=''  target='_blank'> {t("UAA Online Submission")} </a></li> */}
//                           </div>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("Building")}
//                           </a>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${mainURL}/citizen/withoutAuth/license-payment?screenType=main`}
//                           >
//                             {t("CE (Licence Dept.)")}
//                           </a>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${mainURL}/citizen/withoutAuth/license-payment?screenType=swm`}
//                           >
//                             {t("SWM")}
//                           </a>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${prodURL}/citizen/language-selection`}
//                           >
//                             {t("Ch. Valuer & Surveyor")}
//                           </a>
//                         </li>
//                         <button
//                           type="button"
//                           className="btn "
//                           data-toggle="collapse"
//                           data-target="#demo8"
//                         >
//                           {t("Market")}
//                           <i className="bi bi-chevron-down" />
//                         </button>
//                         <div id="demo8" className="collapse">
//                           <li className="nav-item">
//                             <a
//                               className="dropdown-item"
//                               href={`${mainURL}/citizen/language-selection`}
//                             >
//                               {t("Regular Demand")}
//                             </a>
//                           </li>
//                           <li className="nav-item">
//                             <a
//                               className="dropdown-item"
//                               href={`${mainURL}/citizen/language-selection`}
//                             >
//                               {t("Miscellaneous Demand")}
//                             </a>
//                           </li>
//                         </div>
//                         <li className="nav-item">
//                           {/* <Link className="nav-link fontSizeClass" to='/KMC_Advertisement'>{t("Advertisement")}</Link> */}
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("Advertisement")}
//                           </a>
//                         </li>
//                         <button
//                           type="button"
//                           className="btn "
//                           data-toggle="collapse"
//                           data-target="#demo9"
//                         >
//                           {t("Amusement")}
//                           <i className="bi bi-chevron-down" />
//                         </button>
//                         <div id="demo9" className="collapse">
//                           <li className="nav-item">
//                             <a
//                               className="nav-link fontSizeClass"
//                               href={`${mainURL}/citizen/language-selection`}
//                             >
//                               {t("Amusement Fees (Renew/Casual/New)")}
//                             </a>
//                           </li>
//                           <li className="nav-item">
//                             <a
//                               className="nav-link fontSizeClass"
//                               href={`${mainURL}/citizen/language-selection`}
//                             >
//                               {t("Casual Demand Generation and payment")}
//                             </a>
//                           </li>
//                         </div>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${prodURL}/citizen/language-selection`}
//                             target="_blank"
//                           >
//                             {t("Parking")}
//                           </a>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href="/KMC_Central_records_Home"
//                           >
//                             {t("Central Records")}
//                           </a>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${prodURL}/citizen/language-selection`}
//                             target="_blank"
//                           >
//                             {t("Water Supply")}
//                           </a>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${prodURL}/citizen/language-selection`}
//                             target="_blank"
//                           >
//                             {t("Drainage")}
//                           </a>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("Uttaran Services")}
//                           </a>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("Hawker")}
//                           </a>
//                         </li>
//                       </div>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${""}&tenantId=km.kolkata`}
//                       >
//                         {t(
//                           " Public Notice regarding Construction Works within KMC jurisdiction"
//                         )}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"405e6e9d-2854-4a09-a982-d37893b93c03"}&tenantId=km.kolkata`}
//                       >
//                         {t(
//                           "Application Format for obtaining Go-ahead of the Project"
//                         )}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"a255601e-5af8-4c86-a5fa-e4b9bafe61a9"}&tenantId=km.kolkata`}
//                       >
//                         {t("PUBLIC NOTICE - Com/NSO/19, Dated 24.06.2026")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>

//               {/* <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"15d5a40c-f0cf-42af-99ef-bc81a29d751e"}&tenantId=km.kolkata`}
//                       >
//                         {t(" Details of Hon'ble Observers(DEO North)")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div> */}
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${prodURL}/citizen/language-selection`}
//                       >
//                         {t(" Assessment Registration & Payment")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               {/* <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${prodURL}/parking/`}
//                       >
//                         {t(" Check Online Parking Space Availability")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div> */}
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"947b1e64-b3fd-4dcf-abdd-18b785deeb9c"}&tenantId=km.kolkata`}
//                       >
//                         {t(
//                           " Resolution of the 3rd State Level Committee Meeting for Fire Safety and Regulatory Compliances"
//                         )}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"30dac2a7-4765-4939-b14d-21908b225510"}&tenantId=km.kolkata`}
//                       >
//                         {t("Advertisement Policy 2025")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"5de20cb3-e89d-4ef4-afb2-e06abc87b5a9"}&tenantId=km.kolkata`}
//                       >
//                         {t("Weekly Drainage Activity Chart")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"d566421b-ebb5-467d-bf81-cc3e8adaced4"}&tenantId=km.kolkata`}
//                       >
//                         {t(
//                           " DETAILS OF HPV VACCINATION CENTRES UNDER KMC AREA"
//                         )}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>

//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li className="nav-item has-submenu">
//                       <button
//                         type="button"
//                         className="btn"
//                         data-toggle="collapse"
//                         data-target="#demo2"
//                       >
//                         {t("Reprint e-receipt")}
//                         <i className="bi bi-chevron-down" />
//                       </button>
//                       <div id="demo2" className="collapse">
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("License")}
//                           </a>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("SWM")}
//                           </a>
//                         </li>
//                       </div>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/citizen/language-selection`}
//                       >
//                         {t(" EODB SANCTION LIST ")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"b3554452-fb91-4c33-9ea9-75165448535d"}&tenantId=km.kolkata`}
//                       >
//                         {t("  Swachh Vayu Survekshan  ")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               {/* <div className="site-menu quick2">
//               <nav className="sidebar card">
//               <ul className="nav flex-column" id="nav_accordion1">
//                     <li className="nav-item has-submenu">
//                       <button type="button" className="btn " data-toggle="collapse" data-target="#demo1">{t("Check Hearing Notice")}<i className="bi bi-chevron-down" /></button>
//                       <div id="demo1" className="collapse">
//                         <li className="nav-item"><a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/HearingNoticeSearch.jsp' target='_blank'>{t("Property Tax")}</a></li>
//                         <li className="nav-item"><a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/HearingNotice.jsp' target='_blank'>{t("Building")}</a></li>
//                       </div>
//                     </li>
//                   </ul>
//               </nav>
//         </div>*/}

//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"8c9c14f0-a160-4b2f-9677-320362df66fa"}&tenantId=km.kolkata`}
//                       >
//                         {t(" Nagar Bandhu Success Stories ")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${prodURL}/ghats/`}
//                       >
//                         {t("  Burning Ghat Status  ")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/citizen/language-selection`}
//                       >
//                         {t("  Online Permission for Night Parking  ")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>

//               {/* <div className="site-menu quick1">
//               <nav className="sidebar card">
//                 <ul className="nav flex-column" id="nav_accordion">
//                   <li>
//                   <a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/MATCauseList.jsp' target='_blank'>  {t("MAT Cause List")} </a>
//                   </li>
//                 </ul>
//               </nav>
//           </div>
//           <div className="site-menu quick1">
//               <nav className="sidebar card">
//                 <ul className="nav flex-column" id="nav_accordion">
//                   <li>
//                   <a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/MatJudmentFileView.jsp' target='_blank'>  {t("MAT Judgement")} </a>
//                   </li>
//                 </ul>
//               </nav>
//           </div> */}

//               {/* <div className="site-menu quick1">
//               <nav className="sidebar card">
//               <ul className="nav flex-column" id="nav_accordion">
//                     <li className="nav-item has-submenu">
//                         <button type="button" className="btn " data-toggle="collapse" data-target="#demo1a">{t("Print Unpaid Demands")}<i className="bi bi-chevron-down" /></button>
//                         <div id="demo1a" className="collapse quick-scrl">
//                             <li className="nav-item">
//                               <button type="button" className="btn" data-toggle="collapse"  data-target="#demo7">{t("Property Tax")}<i className="bi bi-chevron-down" /></button>
//                                 <div id="demo7" className="collapse">
//                                       <li className="nav-item"><a className="nav-link fontSizeClass" href={`${mainURL}/KMCPortal/jsp/KMCAssesmentAllUnpaidDemand.jsp`} target='_blank'> {t("All Bill")} </a></li>
//                                       <li className="nav-item"><a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp?callbackURL=/KMCPortal/jsp/MiscellaneousSuspensePay.jsp'  target='_blank'> {t("Suspense")}</a></li>
//                                       <li className="nav-item"><a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp'  target='_blank'> {t("UAA Online Submission")} </a></li>
//                                 </div>
//                             </li>
//                             <li className="nav-item"><a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/KMCBuildingPayment.jsp'  target='_blank'>{t("Building")}</a></li>
//                             <li className="nav-item"><a className="nav-link fontSizeClass" href={`${mainURL}/KMCPortal/KMCPortalLicensePaymentAction.do`}  target='_blank'> {t("CE (Licence Dept.)")} </a></li>
//                             <li className="nav-item"><a className="nav-link fontSizeClass" href={`${mainURL}/KMCPortal/jsp/SwmCeFeePayment.jsp`}  target='_blank'> {t("SWM)")} </a></li>
//                             <li className="nav-item"><a className="nav-link fontSizeClass" href={`${mainURL}KMCPortal/jsp/SorDemandPayment.jsp`} target='_blank'> {t("Ch. Valuer & Surveyor")}</a></li>
//                             <button type="button" className="btn " data-toggle="collapse"  data-target="#demo8">{t("Market")}<i className="bi bi-chevron-down" /></button>
//                             <div id="demo8" className="collapse">
//                             <li className="nav-item"><a className="dropdown-item" href='https://www.kmcgov.in/KMCPortal/jsp/MarketPayment.jsp'> {t("Regular Demand")} </a></li>
//                             <li className="nav-item"><a className="dropdown-item" href='https://www.kmcgov.in/KMCPortal/jsp/MarketMiscPayDemand.jsp'> {t("Misclennious Demand")} </a></li>
//                             </div>
//                             <li className="nav-item"><Link className="nav-link fontSizeClass" to='/KMC_Advertisement'>{t("Advertisement")}</Link></li>
//                             <button type="button" className="btn " data-toggle="collapse"  data-target="#demo9">{t("Amusement")}<i className="bi bi-chevron-down" /></button>
//                               <div id="demo9" className="collapse">
//                                   <li className="nav-item"><a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/KMCPortalAmusementPaymentAction.do' target='_blank'>{t("Amusement Fees (Renew/Casual/New)")}</a></li>
//                                   <li className="nav-item"><a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/UserLoginPage.jsp' target='_blank'>{t("Casual Demand Generation and payment")}</a></li>
//                               </div>
//                             <li className="nav-item"><a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/KMCCarParkingPayment.jsp' target='_blank'>{t("Parking")}</a></li>
//                             <li className="nav-item"><a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/KMCPortalWaterSupplyPayment.jsp' target='_blank'>{t("Water Supply")}</a></li>
//                             <li className="nav-item"><a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/KMCPortalDrainagePayment.jsp' target='_blank'>{t("Drainage")}</a></li>
//                             <li className="nav-item"><a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/BusteePayment.jsp' target='_blank'>{t("Bustee")}</a></li>
//                             <li className="nav-item"><a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/HawkerDemandPay.jsp' target='_blank'>{t("Hawker")}</a></li>
//                         </div>
//                     </li>
//                   </ul>
//               </nav>
//           </div> */}
//             </div>

//             <div className="col-lg-4">
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`assets/img/imp-pic/1780729151109Important_CitizenNotice.jpg`}
//                         target="_blank"
//                       >
//                         {t("Important Citizen Notice")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>

//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href="https://www.kmcgov.in/KMCPortal/BuildingMbcResolutionViewAction.do?action=search_appeal"
//                         target="_blank"
//                       >
//                         {t(" MBT Cause List")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>

//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li className="nav-item has-submenu">
//                       <button
//                         type="button"
//                         className="btn "
//                         data-toggle="collapse"
//                         data-target="#demo1a"
//                       >
//                         {t("Print Unpaid Demands")}
//                         <i className="bi bi-chevron-down" />
//                       </button>
//                       <div id="demo1a" className="collapse quick-scrl">
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("Building")}
//                           </a>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("CE (Licence Dept.)")}
//                           </a>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("SWM")}
//                           </a>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("Ch. Valuer & Surveyor")}
//                           </a>
//                         </li>
//                         <button
//                           type="button"
//                           className="btn "
//                           data-toggle="collapse"
//                           data-target="#demo8"
//                         >
//                           {t("Market")}
//                           <i className="bi bi-chevron-down" />
//                         </button>
//                         <div id="demo8" className="collapse">
//                           <li className="nav-item">
//                             <a
//                               className="dropdown-item"
//                               href={`${mainURL}/citizen/language-selection`}
//                             >
//                               {t("Regular Demand")}
//                             </a>
//                           </li>
//                           <li className="nav-item">
//                             <a
//                               className="dropdown-item"
//                               href={`${mainURL}/citizen/language-selection`}
//                             >
//                               {t("Miscellaneous Demand")}
//                             </a>
//                           </li>
//                         </div>
//                         <li className="nav-item">
//                           <a
//                             className="dropdown-item"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("Advertisement")}
//                           </a>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="dropdown-item"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("Amusement")}
//                           </a>
//                         </li>

//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("Parking")}
//                           </a>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("Water Supply")}
//                           </a>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("Drainage")}
//                           </a>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link fontSizeClass"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("Bustee")}
//                           </a>
//                         </li>
//                       </div>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>

//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/citizen/language-selection`}
//                       >
//                         {t(" MBT Judgement")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>

//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"86542f06-003f-4a56-b32f-888e4b6e481a"}&tenantId=km.kolkata`}
//                       >
//                         {t(
//                           "List of Appeal pending for delivery of Judgement before the earlier Bench of MBT-KMC "
//                         )}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>

//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"bc954a1d-4e3c-4add-8aa8-1e3965988636"}&tenantId=km.kolkata`}
//                       >
//                         {t(" Media Note")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href="/List_of_school"
//                       >
//                         {t(" KMCP Schools")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>

//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/citizen/language-selection`}
//                         target="_blank"
//                       >
//                         {t(" Dog Registration ")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18006726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                       >
//                         {t(" West Bengal Right to Public Service Act,2013")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>

//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/citizen/language-selection`}
//                         target="_blank"
//                       >
//                         {t("Ward wise Drainage Network Map ")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/citizen/language-selection`}
//                         target="_blank"
//                       >
//                         {t("Town Vending committee List ")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <Link className="nav-link fontSizeClass" to="/Mom_tvc">
//                         {t("MOM-TVC")}
//                       </Link>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18013826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                       >
//                         {t("  Budget Statement 2026-2027 ")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18006926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                       >
//                         {t("Budget Estimates 2026-2027 ")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//             </div>

//             <div className="col-lg-4">
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18007026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                       >
//                         {t(
//                           " Public Notice of Pollution Control Board, West Bengal "
//                         )}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18007126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                       >
//                         {t("  Advisory regarding prevention of Dengue ")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>

//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"557cb12f-baa8-48c4-abe1-0eeec30e4052"}&tenantId=km.kolkata`}
//                       >
//                         {t("  BSK CENTERS  ")}
//                       </a>
//                       {/* <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'18007226-2a59-4f3c-8a94-891f18042026'}&tenantId=km.kolkata`}>{t("  BSK CENTERS  ")}</a> */}
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"ab888444-a4cb-48b6-9404-25f1c3964c10"}&tenantId=km.kolkata`}
//                       >
//                         {t(" C&D WASTE POLICY ")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"30cd8337-f372-433c-a50e-24ec8f8bd22d"}&tenantId=km.kolkata`}
//                       >
//                         {t(
//                           " Notice inviting application for Certificate course on Climate Change and Sustainable Development "
//                         )}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>

//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18007526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                       >
//                         {t(
//                           "  PROPOSED LIST OF STREETS UNDER DIFFERENT KMC WARDS TO BE RECOMMENDED AS NO VENDING ZONES  "
//                         )}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>

//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"1a7fa2ca-515e-43be-9091-803054a17989"}&tenantId=km.kolkata`}
//                       >
//                         {t(
//                           " Naming and Renaming of Roads in Kolkata from the year 2010 to 2025."
//                         )}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>

//               <div className="site-menu quick2">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion1">
//                     <li className="nav-item has-submenu">
//                       <button
//                         type="button"
//                         className="btn "
//                         data-toggle="collapse"
//                         data-target="#demo1"
//                       >
//                         {t("Check Hearing Notice")}
//                         <i className="bi bi-chevron-down" />
//                       </button>
//                       <div id="demo1" className="collapse">
//                         <li className="nav-item">
//                           <a
//                             className="nav-link"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("Property Tax")}
//                           </a>
//                         </li>
//                         <li className="nav-item">
//                           <a
//                             className="nav-link"
//                             href={`${mainURL}/citizen/language-selection`}
//                           >
//                             {t("Building")}
//                           </a>
//                         </li>
//                       </div>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link"
//                         href={`${mainURL}/citizen/language-selection`}
//                       >
//                         {t("NEFT Payment Information")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/citizen/language-selection`}
//                       >
//                         {t(" Register Your KYC Through External User Login ")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link fontSizeClass"
//                         href={`${mainURL}/citizen/language-selection`}
//                       >
//                         {t(" Find Birth Records ")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>

//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link"
//                         href={`${mainURL}/citizen/language-selection`}
//                       >
//                         {t(" Status of Mutation Application ")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//               <div className="site-menu quick1">
//                 <nav className="sidebar card">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     <li>
//                       <a
//                         className="nav-link"
//                         href={`${mainURL}/citizen/language-selection`}
//                       >
//                         {t(" Building Plan Proposal Status ")}
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Quick_Links;

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { mainURL, prodURL } from "../utils/common";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";
import { ReDirectToeKMC2 } from "../components/ReDirectToeKMC2";

const column1SimpleLinks = [

  {
    type: "file",
    fileStoreId: "",
    label: "Observance of Vigilance Awareness Week 2026 ",
  },

  {
    type: "file",
    fileStoreId: "",
    label: "Designated Disposal Points for Durga Puja Flexes/Banners ",
  },

  {
    type: "file",
    fileStoreId: "",
    label: "Public Guidelines for Puja Immersions, 2026 ",
  },

  {
    type: "file",
    fileStoreId: "",
    label: "Notice for Rebate Date Update ",
  },                            

  {
    type: "file",
    fileStoreId: "",
    label: "Waiver 2026 FlowChart ",
  },

  {
    type: "file",
    fileStoreId: "",
    label: " Waiver 2026 Application Form",
  },

  {
    type: "file",
    fileStoreId: "",
    label: "KMC Waiver Scheme 2026",
  },

  {
    type: "file",
    fileStoreId: "",
    label: "Seva Setu Abhiyan (02.10.2026 to 04.10.2026) Venue Details under KMC Area",
  },

  {
    type: "file",
    fileStoreId: "",
    label: "Kolkata Gazette publication (1728/UDMA, Amendment Schedule II)",
  },

  {
    type: "file",
    fileStoreId: "",
    label: "1728-UDMA-KMC Act-Schedule II Amendment",
  },

  {
    type: "file",
    fileStoreId: "11956d25-939c-4b1d-a0dd-d9a3411692ca",
    label: "Hearing Intimation to Political Parties",
  },

  {
    type: "file",
    fileStoreId: "9a26441a-47e9-4779-8414-51f7965400ec",
    label: "AQI DATA OF KOLKATA",
  },

  {
    type: "file",
    fileStoreId: "8ba1efd8-3956-4acd-ae0a-1c6be3a56120",
    label: "ORDER NO. 1660/UDMA-15011(99)/53/2026-LS-MA SEC Dated 22nd August 2026",
  },

  {
    type: "file",
    fileStoreId: "2c352678-def1-4b0d-ac3b-9420f5f61f6c",
    label: "1590/UDMA-15011(99)/53/2026-LS-MASEC",
  },
  {
    type: "file",
    fileStoreId: "ab14c15a-006e-4399-b39e-0a124cd3b265",
    label: "Cancellation of License u/s 414(4) of KMC Act 1980",
  },

  {
    type: "external",
    href: `https://www.kmcgov.in/KMCPortal/jsp/KMCBuildingNOCGoAhead.jsp`,
    label: "N.O.C / GO AHEAD ORDERS OF BUILDING DEPT. KMC",
  },

  {
    type: "file",
    fileStoreId: "6213a2df-cea0-4ed8-92ee-216a876b6bb0",
    label: "Notification of No Vending Zone",
  },

  {
    type: "file",
    fileStoreId: "fd87bd79-8ad1-46b2-b350-d411bc425ab2",
    label: "Public Notice regarding Construction Works within KMC jurisdiction",
  },

  {
    type: "file",
    fileStoreId: "405e6e9d-2854-4a09-a982-d37893b93c03",
    label: "Application Format for obtaining Go-ahead of the Project",
  },
  {
    type: "file",
    fileStoreId: "a255601e-5af8-4c86-a5fa-e4b9bafe61a9",
    label: "PUBLIC NOTICE - Com/NSO/19, Dated 24.06.2026",
  },
  {
    type: "external",
    href: `${prodURL}/citizen/language-selection`,
    label: "Assessment Registration & Payment",
  },
  {
    type: "file",
    fileStoreId: "947b1e64-b3fd-4dcf-abdd-18b785deeb9c",
    label:
      "Resolution of the 3rd State Level Committee Meeting for Fire Safety and Regulatory Compliances",
  },
  {
    type: "file",
    fileStoreId: "30dac2a7-4765-4939-b14d-21908b225510",
    label: "Advertisement Policy 2025",
  },
  {
    type: "file",
    fileStoreId: "5de20cb3-e89d-4ef4-afb2-e06abc87b5a9",
    label: "Weekly Drainage Activity Chart",
  },
 

];

const column2SimpleLinks = [

  {
    type: "file",
    fileStoreId: "d566421b-ebb5-467d-bf81-cc3e8adaced4",
    label: "DETAILS OF HPV VACCINATION CENTRES UNDER KMC AREA",
  },
  { type: "redirect", label: "EODB SANCTION LIST" },

  {
    type: "file",
    fileStoreId: "b3554452-fb91-4c33-9ea9-75165448535d",
    label: "Swachh Vayu Survekshan  ",
  },
  // {
  //   type: "file",
  //   fileStoreId: "8c9c14f0-a160-4b2f-9677-320362df66fa",
  //   label: "Nagar Bandhu Success Stories ",
  // },
  {
    type: "external",
    href: `${prodURL}/ghats/`,
    label: "Burning Ghat Status  ",
  },

  { type: "redirect", label: "Online Permission for Night Parking  " },
  {
    type: "external",
    href: "assets/img/imp-pic/1780729151109Important_CitizenNotice.jpg",
    target: "_blank",
    label: "Important Citizen Notice",
  },
  {
    type: "external",
    href: "https://www.kmcgov.in/KMCPortal/BuildingMbcResolutionViewAction.do?action=search_appeal",
    target: "_blank",
    label: "MBT Cause List",
  },
  {
    type: "external",
    href: "https://www.kmcgov.in/KMCPortal/jsp/BuildingMbcResolutionView.jsp",
    target: "_blank",
    label: "MBT Judgement",
  },
  // { type: "redirect", label: "MBT Judgement" },
  {
    type: "file",
    fileStoreId: "86542f06-003f-4a56-b32f-888e4b6e481a",
    label:
      "List of Appeal pending for delivery of Judgement before the earlier Bench of MBT-KMC ",
  },
  // {
  //   type: "file",
  //   fileStoreId: "bc954a1d-4e3c-4add-8aa8-1e3965988636",
  //   label: "Media Note",
  // },
  { type: "link", to: "/List_of_school", label: "KMCP Schools" },

  { type: "redirect", target: "_blank", label: "Dog Registration " },
  {
    type: "file",
    fileStoreId: "18006726-2a59-4f3c-8a94-891f18042026",
    label: "West Bengal Right to Public Service Act,2013",
    noClass: true,
  },
  // {
  //   type: "redirect",
  //   target: "_blank",
  //   label: "Ward wise Drainage Network Map ",
  // },
  {
    type: "external",
    href: "https://www.kmcgov.in/KMCPortal/jsp/DrainageNetworkMap.jsp",
    target: "_blank",
    label: "Ward wise Drainage Network Map",
  },
  { type: "redirect", target: "_blank", label: "Town Vending committee List " },
  

];

const column3SimpleLinks = [
  { type: "link", to: "/Mom_tvc", label: "MOM-TVC" },

  {
    type: "file",
    fileStoreId: "18013826-2a59-4f3c-8a94-891f18042026",
    label: "Budget Statement 2026-2027 ",
    noClass: true,
  },
  {
    type: "file",
    fileStoreId: "10840283-7376-4874-b3c4-780c3526e62c",
    label: "Budget Estimates 2026-2027 ",
    noClass: true,
  },
  {
    type: "file",
    fileStoreId: "18007026-2a59-4f3c-8a94-891f18042026",
    label: "Public Notice of Pollution Control Board, West Bengal",
    noClass: true,
  },
  {
    type: "file",
    fileStoreId: "18007126-2a59-4f3c-8a94-891f18042026",
    label: "Advisory regarding prevention of Dengue",
    noClass: true,
  },
  {
    type: "file",
    fileStoreId: "557cb12f-baa8-48c4-abe1-0eeec30e4052",
    label: "BSK CENTERS",
    noClass: true,
  },
  {
    type: "file",
    fileStoreId: "ab888444-a4cb-48b6-9404-25f1c3964c10",
    label: "C&D WASTE POLICY",
    noClass: true,
  },
  {
    type: "file",
    fileStoreId: "30cd8337-f372-433c-a50e-24ec8f8bd22d",
    label:
      "Notice inviting application for Certificate course on Climate Change and Sustainable Development",
    noClass: true,
  },
  {
    type: "file",
    fileStoreId: "18007526-2a59-4f3c-8a94-891f18042026",
    label:
      "PROPOSED LIST OF STREETS UNDER DIFFERENT KMC WARDS TO BE RECOMMENDED AS NO VENDING ZONES",
    noClass: true,
  },
  {
    type: "file",
    fileStoreId: "1a7fa2ca-515e-43be-9091-803054a17989",
    label:
      "Naming and Renaming of Roads in Kolkata from the year 2010 to 2025.",
    noClass: true,
  },
  { type: "redirect", noClass: true, label: "NEFT Payment Information" },
  {
    type: "redirect",
    label: "Register Your KYC Through External User Login",
  },
  { type: "redirect", label: "Find Birth Records" },
  {
    type: "redirect",
    noClass: true,
    label: "Status of Mutation Application",
  },
  { type: "redirect", noClass: true, label: "Building Plan Proposal Status" },
];

const paymentDepartments = [
  { label: "Building" },
  { label: "CE (Licence Dept.)" },
  { label: "SWM" },
  { label: "Ch. Valuer & Surveyor" },
];

const QuickLinkItem = ({ item }) => {
  const { t } = useTranslation();
  const classAdd = !item.noClass;

  let content;
  if (item.type === "file") {
    content = (
      <DownloadFileByFileStoreId
        fileStoreId={item.fileStoreId}
        label={item.label}
        classAdd={classAdd}
      />
    );
  } else if (item.type === "redirect") {
    content = <ReDirectToeKMC2 label={item.label} classAdd={classAdd} />;
  } else if (item.type === "link") {
    content = (
      <Link className={classAdd ? "nav-link fontSizeClass" : ""} to={item.to}>
        {t(item.label)}
      </Link>
    );
  } else {
    content = (
      <a
        className={classAdd ? "nav-link fontSizeClass" : ""}
        href={item.href}
        target={item.target}
        rel={item.target === "_blank" ? "noreferrer" : undefined}
      >
        {t(item.label)}
      </a>
    );
  }

  return (
    <div className="site-menu quick1">
      <nav className="sidebar card">
        <ul className="nav flex-column" id="nav_accordion">
          <li>{content}</li>
        </ul>
      </nav>
    </div>
  );
};

const QuickLinkColumn = ({ items }) => (
  <>
    {items.map((item, idx) => (
      <QuickLinkItem key={`${item.label}-${idx}`} item={item} />
    ))}
  </>
);

const DepartmentLinks = ({ classAdd = true }) => {
  const { t } = useTranslation();
  return (
    <>
      {paymentDepartments.map(({ label }) => (
        <li className="nav-item" key={label}>
          <ReDirectToeKMC2 label={label} classAdd={classAdd} />
        </li>
      ))}
      <button type="button" className="btn" data-toggle="collapse" data-target="#demo8">
        {t("Market")}
        <i className="bi bi-chevron-down" />
      </button>
      <div id="demo8" className="collapse">
        <li className="nav-item">
          <ReDirectToeKMC2 label="Regular Demand" classAdd={false} />
        </li>
        <li className="nav-item">
          <ReDirectToeKMC2 label="Miscellaneous Demand" classAdd={false} />
        </li>
      </div>
    </>
  );
};

const Quick_Links = () => {
  const { t } = useTranslation();
  const showPopup = ()=>{
    console.log("")
    alert("Filled up Hard copy Application Form shall be submitted at the Advertisement Department, KMC from 20 to 25th September (11am to 4pm) to get the NOC")
  }

  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />
        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2"></div>
          </div>
        </div>
      </section>

      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="inner-title2 quick-t">
              <h3> {t("Quick Links")} </h3>
            </div>

            <div className="col-lg-4 quick-scrl">
              <div className="site-menu quick1">
                <nav className="sidebar card">
                  <ul className="nav flex-column" id="nav_accordion">
                    <li className="nav-item has-submenu">
                      <button type="button" className="btn" data-toggle="collapse" data-target="#demo">
                        {t("Make Online Payment")}
                        <i className="bi bi-chevron-down" />
                      </button>
                      <div id="demo" className="collapse quick-scrl">
                        <li className="nav-item">
                          <button
                            type="button"
                            className="btn"
                            data-toggle="collapse"
                            data-target="#demo7"
                          >
                            {t("Property Tax")}
                            <i className="bi bi-chevron-down" />
                          </button>
                          <div id="demo7" className="collapse">
                            <li className="nav-item">
                              <a
                                className="nav-link fontSizeClass"
                                href={`${prodURL}/citizen/withoutAuth/online-payment`}
                              >
                                {t("Pay All Bill(Quick Pay)")}
                              </a>
                            </li>
                            <li className="nav-item">
                              <ReDirectToeKMC2 label="Pay All Bill,Suspense,Misc" />
                            </li>
                          </div>
                        </li>
                        <DepartmentLinks />
                        <li className="nav-item">
                          <ReDirectToeKMC2 label="Advertisement" />
                        </li>
                        <button
                          type="button"
                          className="btn"
                          data-toggle="collapse"
                          data-target="#demo9"
                        >
                          {t("Amusement")}
                          <i className="bi bi-chevron-down" />
                        </button>
                        <div id="demo9" className="collapse">
                          <li className="nav-item">
                            <ReDirectToeKMC2 label="Amusement Fees (Renew/Casual/New)" />
                          </li>
                          <li className="nav-item">
                            <ReDirectToeKMC2 label="Casual Demand Generation and payment" />
                          </li>
                        </div>
                        <li className="nav-item">
                          <a
                            className="nav-link fontSizeClass"
                            href={`${prodURL}/citizen/language-selection`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {t("Parking")}
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link fontSizeClass"
                            href="/KMC_Central_records_Home"
                          >
                            {t("Central Records")}
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link fontSizeClass"
                            href={`${prodURL}/citizen/language-selection`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {t("Water Supply")}
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link fontSizeClass"
                            href={`${prodURL}/citizen/language-selection`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {t("Drainage")}
                          </a>
                        </li>
                        <li className="nav-item">
                          <ReDirectToeKMC2 label="Uttaran Services" />
                        </li>
                        <li className="nav-item">
                          <ReDirectToeKMC2 label="Hawker" />
                        </li>
                      </div>
                    </li>
                  </ul>
                </nav>
              </div>

              <div class="site-menu quick1">
                <nav class="sidebar card">
                  <ul class="nav flex-column" id="nav_accordion">
                    <li > <a class="d-flex align-items-center" onClick={(e)=>showPopup()} href={`${mainURL}/filestore/v1/files/id?fileStoreId=${""}&tenantId=km.kolkata`}>
                      <i class="bi bi-download mr-2"></i> 
                      APPLICATION FORM : NOC for Temporary Advertisement for Durga Puja 2026 </a>
                      </li>                     
                  </ul>
                 
                </nav>
              </div>

              <QuickLinkColumn items={column1SimpleLinks} />

            </div>

            <div className="col-lg-4">

              <div className="site-menu quick1">
                <nav className="sidebar card">
                  <ul className="nav flex-column" id="nav_accordion">
                    <li className="nav-item has-submenu">
                      <button type="button" className="btn" data-toggle="collapse" data-target="#demo2">
                        {t("Reprint e-receipt")}
                        <i className="bi bi-chevron-down" />
                      </button>
                      <div id="demo2" className="collapse quick-scrl">
                        <DepartmentLinks />
                        <li className="nav-item">
                          <ReDirectToeKMC2
                            label="Advertisement"
                            classAdd={false}
                          />
                        </li>
                        <li className="nav-item">
                          <ReDirectToeKMC2 label="Amusement" classAdd={false} />
                        </li>
                        <li className="nav-item">
                          <ReDirectToeKMC2 label="Parking" />
                        </li>
                        <li className="nav-item">
                          <ReDirectToeKMC2 label="Water Supply" />
                        </li>
                        <li className="nav-item">
                          <ReDirectToeKMC2 label="Drainage" />
                        </li>
                        <li className="nav-item">
                          <ReDirectToeKMC2 label="Bustee" />
                        </li>
                      </div>
                    </li>
                  </ul>
                </nav>
              </div>

              {/* <div className="site-menu quick1">
                <nav className="sidebar card">
                  <ul className="nav flex-column" id="nav_accordion">
                    <li className="nav-item has-submenu">
                      <button type="button" className="btn" data-toggle="collapse" data-target="#demo2">
                        {t("Reprint e-receipt")}
                        <i className="bi bi-chevron-down" />
                      </button>
                      <div id="demo2" className="collapse">
                        <li className="nav-item">
                          <ReDirectToeKMC2 label="License" />
                        </li>
                        <li className="nav-item">
                          <ReDirectToeKMC2 label="SWM" />
                        </li>
                      </div>
                    </li>
                  </ul>
                </nav>
              </div> */}

              <QuickLinkColumn
                items={[column2SimpleLinks[0], column2SimpleLinks[1]]}
              />

              <div className="site-menu quick1">
                <nav className="sidebar card">
                  <ul className="nav flex-column" id="nav_accordion">
                    <li className="nav-item has-submenu">
                      <button type="button" className="btn" data-toggle="collapse" data-target="#demo1a">
                        {t("Print Unpaid Demands")}
                        <i className="bi bi-chevron-down" />
                      </button>
                      <div id="demo1a" className="collapse quick-scrl">
                        <DepartmentLinks />
                        <li className="nav-item">
                          <ReDirectToeKMC2
                            label="Advertisement"
                            classAdd={false}
                          />
                        </li>
                        <li className="nav-item">
                          <ReDirectToeKMC2 label="Amusement" classAdd={false} />
                        </li>
                        <li className="nav-item">
                          <ReDirectToeKMC2 label="Parking" />
                        </li>
                        <li className="nav-item">
                          <ReDirectToeKMC2 label="Water Supply" />
                        </li>
                        <li className="nav-item">
                          <ReDirectToeKMC2 label="Drainage" />
                        </li>
                        <li className="nav-item">
                          <ReDirectToeKMC2 label="Bustee" />
                        </li>
                      </div>
                    </li>
                  </ul>
                </nav>
              </div>

              <QuickLinkColumn items={column2SimpleLinks.slice(2)} />
            </div>

            <div className="col-lg-4">
              <QuickLinkColumn items={column3SimpleLinks.slice(0, 7)} />

              <div className="site-menu quick2">
                <nav className="sidebar card">
                  <ul className="nav flex-column" id="nav_accordion1">
                    <li className="nav-item has-submenu">
                      <button
                        type="button"
                        className="btn"
                        data-toggle="collapse"
                        data-target="#demo1"
                      >
                        {t("Check Hearing Notice")}
                        <i className="bi bi-chevron-down" />
                      </button>
                      <div id="demo1" className="collapse">
                        <li className="nav-item">
                          <ReDirectToeKMC2
                            label="Property Tax"
                            classAdd={false}
                          />
                        </li>
                        <li className="nav-item">
                          <ReDirectToeKMC2 label="Building" classAdd={false} />
                        </li>
                      </div>
                    </li>
                  </ul>
                </nav>
              </div>

              <QuickLinkColumn items={column3SimpleLinks.slice(7)} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Quick_Links;
